var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrencysix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Currency 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31 14.7986C31 6.89674 24.2895 0.5 16 0.5C7.71053 0.5 1 6.89674 1 14.7986V19.201H31V14.7986Z",
    fill: "url(#paint0_linear_8056_37780)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.002 4.90246V0.5",
    stroke: "#D9EFFF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.72461 11.0362V6.63379",
    stroke: "#D9EFFF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M28.3164 11.0362V6.63379",
    stroke: "#D9EFFF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.88281 6.18176V1.7793",
    stroke: "#D9EFFF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M22.1602 6.18176V1.7793",
    stroke: "#D9EFFF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M31 14.7986C31 6.89674 24.2895 0.5 16 0.5C7.71053 0.5 1 6.89674 1 14.7986V19.201H31V14.7986Z",
    stroke: "#135BA3",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M16 33.4995C24.2843 33.4995 31 27.0978 31 19.2009C31 11.304 24.2843 4.90234 16 4.90234C7.71573 4.90234 1 11.304 1 19.2009C1 27.0978 7.71573 33.4995 16 33.4995Z",
    fill: "#2775CA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M15.9999 29.7366C22.1041 29.7366 27.0525 25.0196 27.0525 19.2008C27.0525 13.3821 22.1041 8.66504 15.9999 8.66504C9.8957 8.66504 4.94727 13.3821 4.94727 19.2008C4.94727 25.0196 9.8957 29.7366 15.9999 29.7366Z",
    stroke: "#3C8DD6",
    strokeWidth: 6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.762 25.9375L16.6305 25.8999C16.8673 25.8999 17.0647 25.7117 17.0647 25.486L17.0252 24.169C18.841 23.868 19.9463 22.6263 19.9068 21.1211C19.8673 19.1645 18.6041 18.5248 16.1568 18.2991C14.3805 18.1109 14.0252 17.697 13.9857 16.9068C13.9463 16.1543 14.5384 15.5898 15.7226 15.5898C16.7884 15.5522 17.3805 15.8909 17.6568 16.7187C17.7357 16.9068 17.8936 17.0197 18.091 17.0197L18.9989 16.9821C19.2752 16.9821 19.4726 16.7563 19.3936 16.4929C19.0778 15.2136 18.1305 14.461 16.7094 14.2729L16.6699 12.9559C16.6699 12.7301 16.4726 12.542 16.2357 12.542L15.3673 12.5796C15.1305 12.5796 14.9331 12.7678 14.9331 12.9935L14.9726 14.2729C13.2357 14.5363 12.1305 15.6651 12.1699 17.095C12.2094 18.9387 13.3936 19.616 15.8805 19.8794C17.5384 20.1052 18.0515 20.4438 18.0515 21.3469C18.091 22.25 17.3015 22.8897 16.1568 22.8897C14.6173 22.9273 14.1042 22.2876 13.9068 21.4598C13.8673 21.2717 13.6699 21.1211 13.4726 21.1211L12.4857 21.1588C12.2489 21.1588 12.0515 21.3845 12.091 21.6103C12.3673 23.0025 13.3542 23.9809 15.2884 24.2066L15.3278 25.5236C15.3278 25.7494 15.5252 25.9375 15.762 25.9375Z",
    fill: "#CBDFEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0789 28.8722C13.3947 28.9475 13.671 28.7593 13.6315 28.4583L13.592 27.6681C13.592 27.4424 13.3947 27.2166 13.1973 27.1413C9.84204 26.0501 7.31572 23.0399 7.23678 19.4276C7.15783 15.8153 9.4473 12.6922 12.8026 11.4129C12.9999 11.3376 13.1578 11.0742 13.1578 10.8861L13.1184 10.0959C13.1184 9.79489 12.842 9.60675 12.5262 9.71964C8.30257 11.1119 5.34204 14.9875 5.46046 19.4653C5.57888 23.943 8.77625 27.6681 13.0789 28.8722Z",
    fill: "#CBDFEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9607 9.56933C18.6449 9.49407 18.3686 9.68221 18.4081 9.98324L18.4475 10.7734C18.4475 10.9992 18.6449 11.225 18.8423 11.3002C22.237 12.3914 24.7239 15.4016 24.8423 19.0139C24.9607 22.6262 22.6318 25.7493 19.2765 27.0287C19.0396 27.1039 18.9212 27.3297 18.9212 27.5554L18.9607 28.3456C18.9607 28.6467 19.237 28.8348 19.5528 28.7219C23.7765 27.3297 26.737 23.454 26.6186 18.9763C26.4607 14.4986 23.2633 10.7734 18.9607 9.56933Z",
    fill: "#CBDFEF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    opacity: 0.3,
    d: "M29.1041 12.2026L10.7094 32.5593C12.3673 33.1614 14.1436 33.5 16.0383 33.5C16.5515 33.5 17.0252 33.4624 17.5383 33.4248L30.9989 18.5241C30.8804 16.2288 30.2094 14.084 29.1041 12.2026ZM20.1831 5.50488L2.41992 25.1843C3.24887 26.9151 4.43308 28.4579 5.93308 29.7372L25.4726 8.10121C23.9331 6.93474 22.1568 6.03167 20.1831 5.50488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M16 33.4995C24.2843 33.4995 31 27.0978 31 19.2009C31 11.304 24.2843 4.90234 16 4.90234C7.71573 4.90234 1 11.304 1 19.2009C1 27.0978 7.71573 33.4995 16 33.4995Z",
    stroke: "#135BA3",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8056_37780",
    x1: 1.01974,
    y1: 9.86746,
    x2: 31.0197,
    y2: 9.86746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2775CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#045AA8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencysix);
export default __webpack_public_path__ + "static/media/Currencysix.5a34831be96ee73b87ff429d994c75a6.svg";
export { ForwardRef as ReactComponent };